import React from "react";

const SectionLoader = () => {
  return (
    <div className="spinner-box">
      <div
        className="spinner-border"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default SectionLoader;
